import React, { useCallback, useState } from 'react';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';

export default function Support({ handleAPIRequest }) {

    const [alertError, setAlertError] = useState(null)
    const [alertSuccess, setAlertSuccess] = useState(null)

    const [supportRequestCategory, setSupportRequestCategory] = useState(null)
    const [supportMessage, setSupportMessage] = useState('')

    // ************************************************************************
    // Submit Support Question

    const onSubmitSupportRequest = useCallback(() => {
        console.log("Support Question Data:", {
            category: supportRequestCategory,
            message: supportMessage
        });

        const do_post = async () => {
            const res = await handleAPIRequest('/api/v1/send_email', {
                method: 'POST' 
            ,   body: JSON.stringify({
                    to: 'support@healthrate.io',
                    subject: `Support Request: ${supportRequestCategory}`,
                    body: supportMessage
                })
            });
            
            if (res.status === 200) {
                setAlertSuccess({
                    title: 'Support Request Submitted'
                ,   body: 'Your request has been submitted successfully.'
                });
                // Clear the form
                setSupportRequestCategory(null);
                setSupportMessage('');
                setTimeout(() => {setAlertSuccess(null)}, 7000);
                console.log('Support Request submitted successfully'); 
            } 
            else { 
                setAlertError({
                    title: 'Error Submitting Support Request: ',
                    body: res.statusText
                });
                setTimeout(() => {setAlertError(null)}, 5000);
                console.error('Error submitting Support Request', res.statusText);
            }
        }

        do_post();

    }, [handleAPIRequest, supportRequestCategory, supportMessage]);


    return (
        <>
        <Alert show={!!alertError} variant="danger">
            <Alert.Heading>{alertError ? alertError.title : ''}</Alert.Heading>
            <p dangerouslySetInnerHTML={alertError ? { __html: alertError.body } : { __html: '' }}></p>
        </Alert>

        <Alert show={!!alertSuccess} variant="success">
            <Alert.Heading>{alertSuccess ? alertSuccess.title : ''}</Alert.Heading>
            <p dangerouslySetInnerHTML={alertSuccess ? { __html: alertSuccess.body } : { __html: '' }}></p>
        </Alert>
        
        <div className="bg-light mt-4 mb-4 p-3">
            <Row>
                <h1>Support Request</h1>
            </Row>
            <Row className="mt-3">
                <p>We are here to help! Please fill out the form below to submit your support request. Our team will review your inquiry and respond as soon as possible.</p>
            </Row>
            <Row className="mt-3">
                <div className="col-md-6">
                    <select className="form-select" id="support_request_category" onChange={ (e) => setSupportRequestCategory(e.target.value) } value={ supportRequestCategory === null ? "" : supportRequestCategory }>
                        <option value={ "null" } key="support_request_category_null">How can we help you?...</option>
                        <option value={ "Technical Issue" } key="support_request_category_technical_issue">Technical Issue</option>
                        <option value={ "Account Assistance" } key="support_request_category_account_assistance">Account Assistance</option>
                        <option value={ "Billing Inquiry" } key="support_request_category_billing_inquiry">Billing Inquiry</option>
                        <option value={ "Referral Request" } key="support_request_category_referral_request">Referral Request</option>
                        <option value={ "General Question" } key="support_request_category_general_question">General Question</option>
                        <option value={ "Feedback/Suggestions" } key="support_request_category_feedback_suggestions">Feedback/Suggestions</option>
                    </select>
                </div>
            </Row>
            <Row className="mt-3">
                <div className="col-md-10">
                    <textarea 
                        className="form-control" 
                        id="support_request_message" 
                        rows="5" 
                        placeholder="Please describe your issue or question here..."
                        value={supportMessage}
                        onChange={(e) => setSupportMessage(e.target.value)}
                    />
                </div>
            </Row>
            <Row className="mt-4">
                <div className="col-md-12">
                    <Button id="support_submit"
                        onClick={ onSubmitSupportRequest }
                        className="btn btn-primary"
                        style={{ width: '100px' }}
                        disabled={!supportRequestCategory || !supportMessage.trim()}
                    >
                        Submit
                    </Button>
                </div>
            </Row>
        </div>
    </>
    );

}
